import React, { useState } from 'react';
import { toast } from 'sonner';
import { adminLogin, apiError, setAdminToken } from './adminApi';

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const data = await adminLogin(email.trim(), password);
      setAdminToken(data.token);
      toast.success(`Accesso effettuato · ${data.admin.email}`);
      onLogin(data.admin);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="adm-login-wrap" data-testid="admin-login">
      <form className="adm-login" onSubmit={submit}>
        <img src="/images/beautykit-logo.png" alt="BeautyKit" className="adm-logo" />
        <span className="eyebrow">Area riservata</span>
        <h1 className="adm-login-title">Ordini &amp; Spedizioni</h1>
        <label className="adm-field">
          <span>Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required data-testid="admin-email-input" />
        </label>
        <label className="adm-field">
          <span>Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required data-testid="admin-password-input" />
        </label>
        {error && <p className="adm-error" role="alert" data-testid="admin-login-error">{error}</p>}
        <button type="submit" className="btn-pill btn-pill-primary w-full" disabled={busy} data-testid="admin-login-submit">
          {busy ? 'Accesso…' : 'Entra'}
        </button>
        <a href="/" className="adm-back">← Torna al sito</a>
      </form>
    </div>
  );
};

export default AdminLogin;
